import svg4everybody from 'svg4everybody';

export default function() {
    svg4everybody();

    window.itiData ??= {};
    window.itiData.l10n ??= {};
    window.itiData.cookie_consent ??= {};
}
